export default __webpack_public_path__ + "static/media/1 (1000).9a52b663.jpg";